module.exports = __webpack_public_path__ + "media/mapv_1791549808748_27500.68cb0de9.mp4";